// extracted by mini-css-extract-plugin
export default {"container":"CountryCardNav_container__KAIM5","navlink":"CountryCardNav_navlink__3KNOO","active":"CountryCardNav_active__fcFqO"};